import { AlertTriangle } from 'lucide-react';

function shouldShowDevBanner(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  // Matches dev.organize… and the CFP vanity dev host cfp.dev.bsidesboulder.org
  // (the `dev.` label can sit behind a leading subdomain like `cfp.`).
  return (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host.startsWith('dev.') ||
    host.includes('.dev.')
  );
}

export default function DevBanner() {
  if (!shouldShowDevBanner()) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-warning-700 text-white text-sm font-semibold flex items-center justify-center gap-2 px-4 py-1.5"
    >
      <AlertTriangle className="w-4 h-4 flex-shrink-0" aria-hidden="true" />
      <span>
        DEV ENVIRONMENT — data and changes here do not affect production
      </span>
    </div>
  );
}
